import React, { useState, useEffect, useCallback } from 'react'
import DoctorHours from './DoctorHours'
import clinicbookingService from '../../../../../services/clinicbooking.service'
import CustomHours from './CustomHours'
import AddEditDoctorInfo from './AddEditDoctorInfo'
import Loading from "../../../../common/Loading";
import { toast } from 'react-toastify'
function DocInfo({ doc, onBack }) {
    const [doctor, setDoctor] = useState(null)
    const [editInfo, setEditInfo] = useState(false)
    const [apptEdit, setApptEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    // Appointment type management state
    const [docApptType, setDocApptType] = useState([])
    const [allApptType, setAllApptType] = useState([])
    const [isAddAppt, setIsAddAppt] = useState(false)

    const getApptType = useCallback(() => {
        return clinicbookingService.getApptTypeToDoctor(doc.clinicId, doc.id, doc.userId)
            .then(res => {
                setDocApptType(res.data)
            })
            .catch(err => {
                console.log(err)
            })
    }, [doc.clinicId, doc.id, doc.userId])

    const getAllApptType = useCallback(() => {
        return clinicbookingService.getAllApptType(doc.clinicId)
            .then(res => {
                setAllApptType(res.data)
            })
            .catch(err => {
                console.log(err)
            })
    }, [doc.clinicId])

    const getDoctorById = useCallback(() => {
        return clinicbookingService.getDoctorById(doc.clinicId, doc.id)
            .then(res => {
                setDoctor(res.data)
            })
            .catch(err => {
                console.log(err)
            })
    }, [doc.clinicId, doc.id])

    useEffect(() => {
        setIsLoading(true)
        Promise.all([getDoctorById(), getAllApptType(), getApptType()])
            .finally(() => setIsLoading(false))
    }, [getDoctorById, getAllApptType, getApptType])

    const toogleEdit = () => {
        setEditInfo(!editInfo)
    }

    const updateDoc = (doc) => {
        setDoctor(doc)
    }

    const toogleApptEdit = () => {
        setApptEdit(!apptEdit)
    }

    const toogleAddAppt = () => {
        setIsAddAppt(!isAddAppt)
    }

    const handleDeleteAppt = (appt) => {
        const apptData = [appt.appointmentTypeId]
        clinicbookingService.deleteApptTypeToDoctor(appt.clinicId, appt.doctorId, appt.userId, apptData)
            .then(() => {
                getApptType()
            })
            .catch(err => {
                console.log(err)
                toast.error("Failed to remove appointment type")
            })
    }

    const handleAddAppt = (appt) => {
        const newAppt = [appt.id]
        clinicbookingService.addUpdateApptTypeToDoctor(appt.clinicId, doc.id, doc.userId, newAppt)
            .then(() => {
                getApptType()
            })
            .catch(err => {
                console.log(err)
                toast.error("Failed to add appointment type")
            })
    }

    const inApptList = (id) => {
        return docApptType.some(appt => appt.appointmentTypeId === id)
    }

    if (isLoading) {
        return <Loading />
    }

    return (
        <div className="container-fluid">
            {doctor && (
                <>
                    {/* Header Section */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div className="p-1">
                            <button
                                className="btn btn-outline-secondary btn-sm mb-2"
                                onClick={onBack}
                            >
                                <i className="bi bi-arrow-left me-1"></i> Back to Doctors List
                            </button>
                        </div>
                        <div className="d-flex gap-2">
                            <button
                                className={`btn ${apptEdit ? 'btn-danger' : 'btn-outline-primary'} btn-sm`}
                                onClick={toogleApptEdit}
                            >
                                {apptEdit ?
                                    <>
                                        <i className="bi bi-x me-1"></i>
                                        Cancel
                                    </>
                                    :
                                    <>
                                        <i className="bi bi-calendar2-plus me-1"></i>
                                        Edit Appt Types
                                    </>
                                }
                            </button>
                            <button
                                className={`btn ${editInfo ? 'btn-danger' : 'btn-outline-primary'} btn-sm`}
                                onClick={toogleEdit}
                            >
                                {editInfo ?
                                    <>
                                        <i className="bi bi-x me-1"></i>
                                        Cancel
                                    </>
                                    :
                                    <>
                                        <i className="bi bi-pencil me-1"></i>
                                        Edit Info
                                    </>
                                }
                            </button>
                        </div>
                    </div>

                    {editInfo ? (
                        <AddEditDoctorInfo doctor={doctor} updateDoc={updateDoc} toogleEdit={toogleEdit} />
                    ) : (
                        <div className="row">
                            {/* Doctor Profile Card */}
                            <div className="col-lg-4 col-md-5">
                                <div className="card shadow-none card-border">
                                    <div className="card-title mb-1 text-center">
                                        <i className="bi bi-person-badge me-2 text-primary"></i>
                                        Profile Information
                                    </div>
                                    <div className="card-body text-center">
                                        <div className="mb-3">
                                            {doctor.photoUrl ? (
                                                    <img
                                                        src={doctor.photoUrl}
                                                        className="img-fluid rounded-circle shadow"
                                                        alt={doctor.name}
                                                        style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                                                        onError={(e) => {
                                                            e.target.style.display = 'none';
                                                            e.target.nextElementSibling.style.display = 'flex';
                                                        }}
                                                    />
                                                ) :
                                                <div
                                                    className="rounded-circle d-flex align-items-center justify-content-center bg-primary text-white mx-auto"
                                                    style={{
                                                        width: '150px',
                                                        height: '150px',
                                                        fontSize: '3rem',
                                                        display: doctor.photoUrl ? 'none' : 'flex'
                                                    }}
                                                >
                                                    {doctor.name.charAt(0)}
                                                </div>
                                            }
                                        </div>

                                        <div className="mb-0">
                                            <span className={`badge ${doctor.isActive ? 'bg-success' : 'bg-danger'}`}>
                                                <i className={`bi ${doctor.isActive ? 'bi-check-circle' : 'bi-x-circle'} me-1`}></i>
                                                {doctor.isActive ? 'Active' : 'Inactive'}
                                            </span>
                                        </div>
                                        <div className="mb-0 card-title text-primary">{doctor.name}</div>
                                        <div className="text-muted small mb-3">
                                            <div>
                                                <i className="bi bi-calendar me-1"></i>
                                                Created: {doctor.createdAt}
                                            </div>
                                            <div>
                                                <i className="bi bi-arrow-repeat me-1"></i>
                                                Updated: {doctor.modifiedAt}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Doctor Details Card */}
                            <div className="col-lg-8 col-md-7 mb-4">
                                <div className="card card-border shadow-none">
                                    <div className="card-title mb-0 text-center">
                                        <i className="bi bi-info-circle me-2 text-primary"></i>
                                        Details & Biography
                                    </div>
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <h6 className="text-muted mb-3">Biography</h6>
                                            <div className="bg-light p-3 rounded">
                                                {doctor.bio ? (
                                                    <p className="mb-0 small">{doctor.bio}</p>
                                                ) : (
                                                    <p className="text-muted mb-0 fst-italic">No biography available</p>
                                                )}
                                            </div>
                                        </div>

                                        <div className="mb-4">
                                            <h6 className="text-muted mb-3">Appointment Types</h6>
                                            {apptEdit ? (
                                                <div className="card shadow-none card-border">
                                                    <div className="card-header bg-light py-2 d-flex justify-content-between align-items-center">
                                                        <h6 className="mb-0">
                                                            <i className="bi bi-calendar2-plus me-2"></i>
                                                            Manage Appointment Types
                                                        </h6>
                                                        <button className="btn btn-sm btn-danger" onClick={toogleApptEdit}>
                                                            <i className="bi bi-x"></i> Close
                                                        </button>
                                                    </div>

                                                    <div className="card-body p-2">
                                                                {/* Current Appointment Types */}
                                                                <div className="mb-3">
                                                                    <h6 className="border-bottom pb-1 mb-2">Current Appointment Types</h6>

                                                                    {docApptType.length === 0 ? (
                                                                        <div className="alert alert-info py-2 mb-0">
                                                                            <i className="bi bi-info-circle me-1"></i>
                                                                            No appointment types assigned yet.
                                                                        </div>
                                                                    ) : (
                                                                        <div className="list-group">
                                                                            {docApptType.map((docAppt) => (
                                                                                <div key={docAppt.id} className="list-group-item list-group-item-action p-2">
                                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                                        <div>
                                                                                            <span className="fw-medium">{docAppt.apptType}</span>
                                                                                            <small className="text-muted d-block">{docAppt.timeSlot} minutes</small>
                                                                                        </div>
                                                                                        <button
                                                                                            className="btn btn-sm btn-outline-danger"
                                                                                            onClick={() => handleDeleteAppt(docAppt)}
                                                                                            title="Remove appointment type"
                                                                                        >
                                                                                            <i className="bi bi-trash"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                {/* Add Appointment Types Section */}
                                                                {isAddAppt ? (
                                                                    <div className="border-top pt-3">
                                                                        <h6 className="border-bottom pb-1 mb-2">Available Appointment Types</h6>

                                                                        {allApptType.filter(appt => !inApptList(appt.id)).length === 0 ? (
                                                                            <div className="alert alert-warning py-2">
                                                                                <i className="bi bi-exclamation-triangle me-1"></i>
                                                                                No additional appointment types available to add.
                                                                            </div>
                                                                        ) : (
                                                                            <div className="list-group">
                                                                                {allApptType.map((appointment) => {
                                                                                    if (inApptList(appointment.id)) return null

                                                                                    return (
                                                                                        <div key={appointment.id} className="list-group-item list-group-item-action p-2">
                                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                                <div>
                                                                                                    <span className="fw-medium">{appointment.apptType}</span>
                                                                                                    <small className="text-muted d-block">{appointment.timeSlot} minutes</small>
                                                                                                </div>
                                                                                                <button
                                                                                                    className="btn btn-sm btn-success"
                                                                                                    onClick={() => handleAddAppt(appointment)}
                                                                                                    title="Add appointment type"
                                                                                                >
                                                                                                    <i className="bi bi-plus"></i> Add
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                })}
                                                                            </div>
                                                                        )}

                                                                        <div className="mt-3 text-center">
                                                                            <button className="btn btn-sm btn-outline-secondary" onClick={toogleAddAppt}>
                                                                                <i className="bi bi-arrow-left me-1"></i> Back to List
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="text-center">
                                                                        <button
                                                                            className="btn btn-sm btn-primary"
                                                                            onClick={toogleAddAppt}
                                                                            disabled={allApptType.filter(appt => !inApptList(appt.id)).length === 0}
                                                                        >
                                                                            <i className="bi bi-plus-circle me-1"></i> Add Appointment Type
                                                                        </button>
                                                                    </div>
                                                                )}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div>
                                                    {/* FIXED: Check docApptType instead of doctor.apptTypes */}
                                                    {docApptType.length > 0 ? (
                                                        <div className="d-flex flex-wrap gap-2">
                                                            {docApptType.map((type, index) => (
                                                                <span key={index} className="badge bg-primary px-3 py-2">
                                                                    <i className="bi bi-clock me-1"></i>
                                                                    {type.apptType} ({type.timeSlot} mins)
                                                                </span>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div className="alert alert-info py-2">
                                                            <i className="bi bi-info-circle me-2"></i>
                                                            No appointment types assigned yet
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Hours Sections */}
                    {!editInfo && !apptEdit && (
                        <div className="row g-3">
                            <div className="col-12 clinic-booking-hours-panel">
                                <div className="mb-3">
                                    <h5 className="clinic-booking__title mb-1">
                                        <i className="bi bi-clock text-primary me-1"></i>
                                        Regular Hours
                                    </h5>
                                    <p className="text-muted small mb-0">Default weekly working schedule for this doctor.</p>
                                </div>
                                <DoctorHours id={doc.id} clinicid={doc.clinicId} />
                            </div>

                            <div className="col-12 clinic-booking-custom-hours-panel">
                                <CustomHours doctorid={doc.id} clinicid={doc.clinicId} userid={doc.userId} />
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

export default DocInfo